import { NotifyTypeEnum } from "../../constants/notify";
import { notify } from "./notify";

/**
 * Extract first error message from validation errors
 * @param errors - Object containing field errors with array of error messages
 * @param defaultMessage - Default error message if no errors found
 * @returns First error message or default message
 */
export const getFirstErrorMessage = (
  errors: Record<string, string[]> | undefined,
  defaultMessage: string = "エラーが発生しました。"
): string => {
  if (!errors) return defaultMessage;

  // Get the first field with errors
  const firstField = Object.keys(errors)[0];
  if (!firstField) return defaultMessage;

  // Get the first error message for that field
  const fieldErrors = errors[firstField];
  if (!fieldErrors || fieldErrors.length === 0) return defaultMessage;

  return fieldErrors[0];
};

// Get message 400
const MSG_ERROR_400: Record<string, string> = {
  "An unexpected error occurred. Please try again later.":
    "予期しないエラーが発生しました。恐れ入りますが、もう一度お試しください。"
};

// Get massage no data
const MSG_ERROR_NO_DATA: Record<string, string> = {
  "Network Error": "通信エラー"
};

/**
 * Handle error processing in onError callbacks for TanStack Query mutations
 * @param error - Error object from TanStack Query
 * @param defaultMessage - Default error message if no specific error found
 */
export const handleMutationError = (error: any, defaultMessage: string = "エラーが発生しました。") => {
  const status = error?.response?.status;
  const data = error?.response?.data;

  const getErrorMessage = (): string => {
    if (!data) return MSG_ERROR_NO_DATA[error?.message] || error?.message || defaultMessage;

    switch (status) {
      case 400:
        return MSG_ERROR_400[data?.message] || data?.message || defaultMessage;
      case 422:
        // Check if data?.errors exists and has values
        if (data?.errors && Object.keys(data.errors).length > 0) {
          const errorMessage = getFirstErrorMessage(data.errors);
          // Only use errorMessage if it's not the default message (meaning errors were found)
          if (errorMessage !== defaultMessage) {
            return errorMessage;
          }
        }
        // If no errors or errors is empty, use data?.message
        return data?.message || defaultMessage;
      case 429:
        return "現在、操作が集中しているため処理できません。しばらく時間をおいてから再度お試しください。";
      default:
        if (data.success === false) {
          return getFirstErrorMessage(data.errors) || data?.message || defaultMessage;
        }
        return error?.message || defaultMessage;
    }
  };

  notify(getErrorMessage(), NotifyTypeEnum.ERROR);
};
